import { Component, Input, Output, EventEmitter, TemplateRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Input() header: string = '';
  @Input() headerTemplate?: TemplateRef<any>;
  @Input() width: string = '500px';
  @Input() styleClass: string = 'custom-modal';
  @Input() modal: boolean = true;
  @Input() closable: boolean = true;
  @Input() showHeader: boolean = true;
  @Input() draggable: boolean = false;
  @Input() resizable: boolean = false;
  @Input() contentTemplate?: TemplateRef<any>;
  @Input() footerTemplate?: TemplateRef<any>;
  @Input() showFooter: boolean = true;
  @Input() confirmLabel: string = 'Confirm';
  @Input() cancelLabel: string = 'Cancel';
  @Input() showCancelButton: boolean = true;
  @Input() showConfirmButton: boolean = true;
  @Input() confirmButtonDisabled: boolean = false;
  @Input() preventAutoCloseOnCancel: boolean = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onConfirm = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {}

  handleVisibleChange(visible: boolean): void {
    this.visible = visible;
    this.visibleChange.emit(visible);
    
    if (!visible) {
      this.onClose.emit();
    }
  }

  handleConfirm(): void {
    // Don't proceed if button is disabled
    if (this.confirmButtonDisabled) {
      return;
    }
    this.onConfirm.emit();
    this.handleVisibleChange(false);
  }

  handleCancel(): void {
    // Emit the cancel event first
    this.onCancel.emit();
    // Only auto-close if preventAutoCloseOnCancel is false
    // This allows parent components to handle async operations before closing
    if (!this.preventAutoCloseOnCancel) {
      this.handleVisibleChange(false);
    }
  }
}

